(function ($) {

    'use strict';

    function ProductFootbar() {
        this.settings = {
            height: 0
        };

        this.load();
    };

    ProductFootbar.prototype = $.extend({}, ProductFootbar.prototype, {
        duration: function () {
            return 400;
        },
        load: function () {
            var _ = this,
                $spacer = $('.js-footer'),
                $newFootbar = $('#new-product-footer'),
                $newLimit = $('[data-js-product-new-footbar-limit]');

            if (window.innerWidth <= 1024) {
                if ($newFootbar.length && $newLimit.length) {
                    $window.on('load', function () {
                        _._checkVisible($newFootbar, $newLimit, $spacer);
                    });
                }
            }
        },
        _checkVisible: function ($footbar, $limit, $spacer) {
            var limit = $limit[0].getBoundingClientRect(),
                stickyHeader = document.querySelector('sticky-header'),
                topSpacing = stickyHeader && stickyHeader.getStickyHeight ? stickyHeader.getStickyHeight() : 0,
                height = $footbar.innerHeight();

            if (limit.top < topSpacing && !$footbar.hasClass('footbar-product--visible')) {
                $footbar.addClass('footbar-product--visible');

                $footbar.stop().slideDown({
                    duration: this.duration(),
                    complete: function () {

                    }
                });

                this.settings.height = $footbar.children().first().innerHeight();
            } else if (limit.top >= topSpacing && $footbar.hasClass('footbar-product--visible')) {
                $footbar.removeClass('footbar-product--visible');

                $footbar.stop().slideUp({
                    duration: this.duration(),
                    complete: function () {

                    }
                });

                this.settings.height = 0;
            }

            if (height > 0) {
                if (this.is_mobile()) {
                    $spacer.css({
                        paddingBottom: ''
                    });

                    $spacer.parent().css({
                        paddingBottom: height
                    });
                } else {
                    $spacer.css({
                        paddingBottom: height
                    });

                    $spacer.parent().css({
                        paddingBottom: ''
                    });
                }
            }


        },
        getFootbarHeight: function () {
            return this.settings.height;
        },
        is_mobile: function () {
            const userAgentInfo = navigator.userAgent;
            const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
            let is_mobile = false;
            for (var v = 0; v < mobileAgents.length; v++) {
                if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
                    is_mobile = true;
                    break;
                }
            }
            return is_mobile;
        },
        destroy: function () {
            $window.unbind('theme.resize.productFootbar scroll.productFootbar');
        }
    });
    document.addEventListener('DOMContentLoaded', () => {
        new ProductFootbar();
    });
})(jQuery);